module.exports = __webpack_public_path__ + "static/9baf2437-bfe5-4bba-bb0b-84aa071d5250-250.c954277a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/decanter-sea-green/9baf2437-bfe5-4bba-bb0b-84aa071d5250-250.jpg
// module id = 943
// module chunks = 168707334958949